import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatSort, MatTableDataSource, MatPaginator, MatDialog,MatSidenav } from '@angular/material';
import { AssetService } from './assetservice';
import {EditAsset, getAssetData, deleteAssetData } from './asset';
import {Router} from '@angular/router';
import { RollbarService } from '../../rollbar';
import * as Rollbar from 'rollbar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { SessionCheck, generateAlertMessage, AuthFailedMessage} from '../../app-general';
import { MapSyncProcess } from '../../api';
import { MainLayoutService } from '../../main-layout/main-layout.service';
import { SidenavComponent } from '../../main-layout/sidenav/sidenav.component';
import { InfrastructureAlertsComponent } from '../../main-layout/alerts/infrastructure-alerts/infrastructure-alerts.component';
import { AddAssetComponent } from './add-asset/add-asset.component';
import { EditAssetComponent } from './edit-asset/edit-asset.component';
import { DownnloadAssetComponent } from './downnload-asset/downnload-asset.component';
import { ConfirmMessageComponent } from '../../confirm-message/confirm-message.component';
import { ApiService } from '../../api.service';
import {appsettings} from '../../app-settings';

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  providers: [ AssetService ],
  styleUrls: ['./asset.component.scss']
})
export class AssetComponent implements OnInit {


  dataSource;
  dataSourcecount;
  displayedColumns: string[] = ['TagId', 'AssetName','AssetNameAlias','AssetType', 'edit', 'delete'];
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  bAddEdit:boolean=true;
  bDelete:boolean=true;
  assetloading = true;
  downloadAssetSource;
  assetsortedData = [];
  SiteId = '1';
  asset_MapSyncProcess;
  assets : any[];
  
  @ViewChild ('rightNav') public rightNav: MatSidenav; 
  chksearchvalue;
private _onDestroy: Subject<void> = new Subject<void>();
constructor(private router: Router,public dialog: MatDialog,@Inject(RollbarService) private rollbar: Rollbar,public mainLayoutService: MainLayoutService
,private mediaObserver: MediaObserver,private assetService: AssetService,private apiService: ApiService) {   

  mediaObserver.media$.subscribe((change: MediaChange) => {  
    if (change.mqAlias == this.xscurrentScreenWidth) {
        this.setupTableforXtrasmallerwidth();
    }
    else if (change.mqAlias == this.smcurrentScreenWidth) 
    {
        this.setupTableforsmallerwidth();
    }
    else
    {
      this.setupFullTable();
    }	
  });
}

@ViewChild(MatSort) sort: MatSort;
@ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.getassetdata();       
  }

setupTableforXtrasmallerwidth() {
    this.displayedColumns = ['TagId', 'AssetName','edit', 'delete'];      
};
setupTableforsmallerwidth()
{
  this.displayedColumns = ['TagId', 'AssetName','AssetType', 'edit', 'delete'];
}
setupFullTable() {
    this.displayedColumns = ['TagId', 'AssetName','AssetNameAlias','AssetType', 'edit', 'delete'];       
};

getassetdata(): void {
 try
 {
  this.assetloading = true;
  var residentdata : getAssetData = 
  {     
    authKey: localStorage.getItem("Authkey")
  };
  this.assetService.getAsset(residentdata).pipe(takeUntil(this._onDestroy))
    .subscribe((Asset : any[])=>{ 
      this.assetloading = false;      
      this.assets = Asset["apiReturn"];
        this.dataSource = new MatTableDataSource(this.assets); 
        this.downloadAssetSource = new MatTableDataSource(this.assets);           
            if(this.chksearchvalue == undefined)                  
            {              
              this.dataSource.data = this.assets;              
              this.dataSourcecount= this.dataSource.data.length;
               this.downloadAssetSource.data = this.assets;
            }
            else
            {
              this.searchAsset(this.chksearchvalue);  
              this.dataSourcecount= this.dataSource.filteredData.length;       
            } 
             setTimeout(() => { 
             this.assetsortedData = [];          
             this.dataSource.sort = this.sort; 
             this.sortingDatalist(this.dataSource);                        
             this.downloadAssetSource.sort = this.sort;
             this.sortingDatalist(this.downloadAssetSource);           
             this.downloadAssetSource.connect().subscribe(data => this.assetsortedData = data); 
          }, 0);           
           
             this.dataSource.paginator = this.paginator;    
      
    });
 }
   catch (err) {
    throw new Error('asset.component.ts' + ' - getassetdata() - ' + err.message);
  }
}

searchAsset(filterValue: string) {
    if (filterValue !=null)
    {
     
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.chksearchvalue = filterValue;
      this.dataSource.filter = filterValue; 
      this.searchfilter(); 
      this.assetsortedData = this.dataSource.filteredData;
      this.dataSourcecount=this.dataSource.filteredData.length;
      setTimeout(() => {           
        this.dataSource.sort = this.sort;
        this.downloadAssetSource.sort = this.sort;               
        this.downloadAssetSource.connect().subscribe(data => this.assetsortedData = data);                    
     }, 0);
    }
}

searchfilter()
{
  this.dataSource.filterPredicate = function(data, filter: string): boolean {       
    var filterinfo=filter.toLowerCase();
    return data.AssetName.toLowerCase().includes(filterinfo) || data.AssetNameAlias.toLowerCase().includes(filterinfo) || 
           data.TagId.toString().includes(filterinfo) || data.AssetType.toLowerCase().includes(filterinfo);	   
  }; 
}

/*********Openadddialogwindow*******/
downloadAssetdata()
{
  if(!SessionCheck(this.router))
  {
      return;
  }
  if(this.dataSource.filter != '')
  {
    this.downloadAssetSource.data = this.dataSource.filteredData;
    setTimeout(() => {        
      this.dataSource.sort = this.sort;   
      this.dataSource.connect().subscribe(data => this.assetsortedData = data);   
   }, 0);      
  }    
  var assetdata = this.assetsortedData;  
  const dialogRef = this.dialog.open(DownnloadAssetComponent, {
    disableClose: true,
    width: '388px',
    height: '165px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data: assetdata
  });
  dialogRef.afterClosed().subscribe(result => {
    let element1 = document.getElementById('downloadbtn');
    element1.className = 'clsassetaddbutton mat-raised-button mat-primary ng-star-inserted'; 
  });
}
addAssetdata() { 
  
 if(!SessionCheck(this.router))
 {
     return;
 }
 let assetlistelement = document.getElementById('divassetdetails');
     assetlistelement.className = 'clsdisable';
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  };
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.asset_MapSyncProcess = MapSyncinfo  
    if(this.asset_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let assetlistelement = document.getElementById('divassetdetails');
          assetlistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      let dialogRef = this.dialog.open(AddAssetComponent, {
        disableClose: true,
        width: '900px',
        height:'350px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data:this.dataSource.data
      });
      dialogRef.afterClosed().subscribe(result => {  
        let assetlistelement = document.getElementById('divassetdetails');
            assetlistelement.className = 'clsenable'; 
        if(result == 'Confirm')
        {
          let element = document.getElementById('btnaddasset');
          element.className = 'clsassetaddbutton mat-raised-button mat-primary ng-star-inserted';    
          this.getassetdata();
        }
        else
        {
          let element = document.getElementById('btnaddasset');
          element.className = 'clsassetaddbutton mat-raised-button mat-primary ng-star-inserted';    
        }
      })
    }
  })
}

editAssetdata(data)
{
  let assetlistelement = document.getElementById('divassetdetails');
      assetlistelement.className = 'clsdisable';
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  };
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.asset_MapSyncProcess = MapSyncinfo  
    if(this.asset_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let assetlistelement = document.getElementById('divassetdetails');
          assetlistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      let editdata: EditAsset = 
        {     
          TagId: data.TagId,
          AssetName: data.AssetName,
          AssetNameAlias: data.AssetNameAlias,
          AssetType: data.AssetType,
          AssetId: data.AssetId      
        }

        let dialogRef = this.dialog.open(EditAssetComponent, {
          disableClose: true,
          width: '900px',
          height:'350px',
          panelClass: 'myapp-no-padding-dialog',
          autoFocus: false,
          data: editdata
        });
      
        dialogRef.afterClosed().subscribe(result => { 
          let assetlistelement = document.getElementById('divassetdetails');
              assetlistelement.className = 'clsenable'; 
          if(result== 'Confirm') 
          {        
            this.getassetdata();
          }       
        })
      }
    })
}

deleteAssetdata(data)
{
  let assetlistelement = document.getElementById('divassetdetails');
      assetlistelement.className = 'clsdisable';
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  };
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.asset_MapSyncProcess = MapSyncinfo  
    if(this.asset_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let assetlistelement = document.getElementById('divassetdetails');
          assetlistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      var deleteasset : deleteAssetData = {
          siteId: this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          assetId: data.AssetId
      } 
      this.confirmation(deleteasset,data);   
    }
  })
 
}
confirmation(deleteasset,data)
{
  try
  {
   
    var ConfirmMessageData = {
      ConfirmMessage:  "Are you sure you want to delete this asset "+data.AssetName+" ( "+data.TagId+" ) details? "                
    }     
    let dialogRef = this.dialog.open(ConfirmMessageComponent, {
      disableClose: true,
      width: 'auto',
      height: '220px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ConfirmMessageData
    });     
    dialogRef.afterClosed().subscribe(result => {     
      if(result == "Yes")
      {                     
         this.deleteAsset(deleteasset) ;           
      }
      else
      {
        let assetlistelement = document.getElementById('divassetdetails');
            assetlistelement.className = 'clsenable';
          dialogRef.close('Cancel');          
          return;
      }
    });
  }
  catch(err)
  {
      throw new Error('delete-device.component.ts' + ' - confirmation() - ' + err.message);
  }   
}


deleteAsset(deleteasset)
{
this.assetService.deleteAsset(deleteasset).pipe(takeUntil(this._onDestroy))
  .subscribe((apiresponse : any[])=>{     
    let assetlistelement = document.getElementById('divassetdetails');
        assetlistelement.className = 'clsenable';
      if (apiresponse !=null && apiresponse !=undefined)
      {  
          if(apiresponse["apiReturn"] == "Success")
          { 	                                 
            generateAlertMessage(this.dialog, 'Asset details deleted successfully.')                  
          }
          else if(apiresponse["apiReturn"] == "Fail")
          {                  
            generateAlertMessage(this.dialog, 'Asset details deleted failed.')                  
          } 
          else if (apiresponse["apiReturn"] == "Invalid Auth Key") {           
            AuthFailedMessage(this.dialog, this.router);
            return;
          }
          this.getassetdata();              
      }
      else
      {                
        generateAlertMessage(this.dialog, 'Asset details deleted failed.')               
      }
      
  });
}
sortingDatalist(DataSource)
{
    DataSource.sortingDataAccessor = function(data, sortHeaderId: string) {               
      if(sortHeaderId != 'TagId')
      {               
        return data[sortHeaderId].toString().toLocaleLowerCase().trim('');                
      }   
      else
      {                
        return data[sortHeaderId]; 
      }                                    
    }
}
CloseRightNav(){  
  if(SidenavComponent.isClosed == false)
  {
      this.mainLayoutService.toggleSideNavRight.emit();
  }
  if(InfrastructureAlertsComponent.isinfraClosed == false)
  {
      this.mainLayoutService.toggleinfrastructureLeft.emit("close");
  }   
}
 ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}

}
